export default __webpack_public_path__ + "static/media/m_use_action_cz.88573313.png";